import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { useApiMutation } from '@/modules/common';
import { EventNumberField } from './event-number-field';

interface InventoryAmountInputProps {
  eventId: string;
  productId: string;
  sizeId: string;
  stationId: string;
  defaultValue: string;
}

const MAX_AMOUNT_PER_SIZE = 1000;

export function InventoryAmountInput({
  eventId,
  productId,
  sizeId,
  stationId,
  defaultValue,
}: InventoryAmountInputProps) {
  const queryClient = useQueryClient();

  const updateProductAmountMutation = useApiMutation<{
    amount: number;
  }>(
    `/events/${eventId}/stations/${stationId}/products/${productId}/sizes/${sizeId}`,
    {
      method: 'PATCH',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  const handleUpdateInventoryAmount = async (value: number) => {
    try {
      await updateProductAmountMutation.mutateAsync({
        amount: Number(value),
      });
      queryClient.invalidateQueries({
        queryKey: ['eventProducts', eventId, stationId],
      });
    } catch (error) {
      console.error('Uh oh! Something went wrong.');
    }
  };

  return (
    <EventNumberField
      defaultValue={defaultValue}
      maxValue={MAX_AMOUNT_PER_SIZE}
      onChange={handleUpdateInventoryAmount}
    />
  );
}
